import { prefectures } from '@gyym/sdk'
import React from 'react'

import { getAddress } from '@/externals/postalCodeApi'

export const useAddress = (postalCode?: string) => {
  const [{ prefecture, address }, setAddress] = React.useState<{
    prefecture?: (typeof prefectures)[number]
    address: string
  }>({
    prefecture: undefined,
    address: '',
  })

  React.useEffect(() => {
    if (!postalCode) return

    const value =
      postalCode.length === 8
        ? postalCode.replace(/-/g, '')
        : postalCode.length === 7
        ? postalCode
        : null

    if (!value || value.length !== 7) return

    const fetch = async () => {
      const { data: addresses } = await getAddress(value)

      if (!addresses) return

      const [{ ja }] = addresses

      const prefectureName = ja.prefecture
      const prefecture = prefectures.find((p) => p.name === prefectureName)

      setAddress({
        prefecture,
        address: `${ja.address1}${ja.address2}`,
      })
    }

    fetch()
  }, [postalCode])

  return { prefecture, address }
}
